import { MerchPageContentBlock, merchPageContentBlocks } from 'app/blocks'
import { gql } from 'graphql-request'

interface MerchPageContent {
  pageContent: MerchPageContentBlock[]
  merchCollection: {
    id: string
    name: string
    slug: string
  }
}

export const createMerchPageQuery = () => gql`
  ${merchPageContentBlocks}
  query getMerchPage {
    Merch {
      merchCollection {
        id
        name
        slug
      }
      pageContent {
        __typename
        ...bannerFragment
        ...callToActionFragment
        ...productGridFragment
        ...promoCodeFragment
      }
    }
  }
`

export const mapToMerchPageContent = (data: any): MerchPageContent => {
  return {
    pageContent: data.Merch.pageContent as MerchPageContentBlock[],
    merchCollection: data.Merch.merchCollection,
  }
}
